<div class="wounds-section">
  <div class="section-header">
    <span class="section-title">
      {{ sectionTitle | translate }}
    </span>
    <div class="progress-bar" *ngIf="showProgressBar">
      <div class="progress-fill"></div>
    </div>
  </div>

  <div class="empty-state" *ngIf="!wounds || wounds.length === 0">
    <i class="fa-solid fa-bandage"></i>
    <p>{{ emptyStateText | translate }}</p>
  </div>

  <div
    class="wound-timeline-list"
    *ngIf="groupedWounds && groupedWounds.length > 0"
  >
    <div class="wound-group" *ngFor="let group of groupedWounds">
      <div class="wound-timeline-row">
        <!-- Parent Wound -->
        <a
          class="wound-timeline-item"
          [class]="
            getStatusClass(group.parent.woundStatus, group.parent.isActive)
          "
          [class.has-tooltip]="group.parent.woundStatus === 2"
          [routerLink]="
            navigateOnClick
              ? ['/patient', patientId, 'wound', group.parent.id, 'assessment']
              : null
          "
          (click)="handleWoundClick($event, group.parent.id)"
          (mouseenter)="
            group.parent.woundStatus === 2 ? showTooltip($event, getDoctorName(group.parent)) : null
          "
          (mousemove)="
            group.parent.woundStatus === 2
              ? updateTooltipPosition($event)
              : null
          "
          (mouseleave)="group.parent.woundStatus === 2 ? hideTooltip() : null"
        >
          <div class="wound-timeline-dot"></div>
          <div class="wound-timeline-status-text">
            {{ getWoundStatusKey(group.parent.woundStatus) | translate }}
          </div>
          <div class="wound-timeline-date" *ngIf="group.parent.createdDateTime">
            {{ group.parent.createdDateTime | date: "dd.MM.yyyy" }}
          </div>
        </a>

        <!-- Connector if children exist -->
        <div
          class="wound-timeline-connector follow-up-connector"
          *ngIf="group.children.length > 0"
          [class]="
            getStatusClass(
              group.children[0].woundStatus,
              group.children[0].isActive
            )
          "
        ></div>

        <!-- Children Wounds -->
        <ng-container *ngFor="let child of group.children; let i = index">
          <a
            class="wound-timeline-item"
            [class]="getStatusClass(child.woundStatus, child.isActive)"
            [class.has-tooltip]="child.woundStatus === 2"
            [routerLink]="
              navigateOnClick
                ? ['/patient', patientId, 'wound', child.id, 'assessment']
                : null
            "
            (click)="handleWoundClick($event, child.id)"
            (mouseenter)="
              child.woundStatus === 2 ? showTooltip($event, getDoctorName(child)) : null
            "
            (mousemove)="
              child.woundStatus === 2 ? updateTooltipPosition($event) : null
            "
            (mouseleave)="child.woundStatus === 2 ? hideTooltip() : null"
          >
            <div class="wound-timeline-dot"></div>
            <div class="wound-timeline-status-text">
              {{ getWoundStatusKey(child.woundStatus) | translate }}
            </div>
            <div class="wound-timeline-date" *ngIf="child.createdDateTime">
              {{ child.createdDateTime | date: "dd.MM.yyyy" }}
            </div>
          </a>

          <!-- Connector to next child -->
          <div
            class="wound-timeline-connector follow-up-connector"
            *ngIf="i < group.children.length - 1"
            [class]="
              getStatusClass(
                group.children[i + 1].woundStatus,
                group.children[i + 1].isActive
              )
            "
          ></div>
        </ng-container>
        <button
          *ngIf="canArchive(group)"
          class="archive-btn"
          (click)="onArchive(group)"
          [disabled]="archivingWoundId === getArchiveWoundId(group)"
        >
          <i
            class="fa-solid"
            [class.fa-box-archive]="
              archivingWoundId !== getArchiveWoundId(group)
            "
            [class.fa-spinner]="archivingWoundId === getArchiveWoundId(group)"
            [class.fa-spin]="archivingWoundId === getArchiveWoundId(group)"
          ></i>
          <span>{{ "archive" | translate }}</span>
        </button>
        <button
          *ngIf="isGroupArchived(group)"
          class="unarchive-btn"
          (click)="onUnarchive(group)"
          [disabled]="archivingWoundId === getArchiveWoundId(group)"
        >
          <i
            class="fa-solid"
            [class.fa-box-open]="archivingWoundId !== getArchiveWoundId(group)"
            [class.fa-spinner]="archivingWoundId === getArchiveWoundId(group)"
            [class.fa-spin]="archivingWoundId === getArchiveWoundId(group)"
          ></i>
          <span>{{ "unarchive" | translate }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Doctor Name Tooltip -->
  <div
    class="doctor-tooltip"
    *ngIf="activeTooltip"
    [style.left.px]="activeTooltip.x"
    [style.top.px]="activeTooltip.y"
  >
    {{ activeTooltip.text }}
  </div>
</div>
